var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8891 7.52513C14.2796 7.1346 14.2796 6.50144 13.8891 6.11091C13.4986 5.72039 12.8654 5.72039 12.4749 6.11091L13.8891 7.52513ZM6.11091 12.4749C5.72039 12.8654 5.72039 13.4986 6.11091 13.8891C6.50144 14.2796 7.1346 14.2796 7.52513 13.8891L6.11091 12.4749ZM12.4749 13.8891C12.8654 14.2796 13.4986 14.2796 13.8891 13.8891C14.2796 13.4986 14.2796 12.8654 13.8891 12.4749L12.4749 13.8891ZM7.52513 6.11091C7.1346 5.72039 6.50144 5.72039 6.11091 6.11091C5.72039 6.50144 5.72039 7.1346 6.11091 7.52513L7.52513 6.11091ZM18 10C18 14.4183 14.4183 18 10 18V20C15.5228 20 20 15.5228 20 10H18ZM10 18C5.58172 18 2 14.4183 2 10H0C0 15.5228 4.47715 20 10 20V18ZM2 10C2 5.58172 5.58172 2 10 2V0C4.47715 0 0 4.47715 0 10H2ZM10 2C14.4183 2 18 5.58172 18 10H20C20 4.47715 15.5228 0 10 0V2ZM12.4749 6.11091L9.29289 9.29289L10.7071 10.7071L13.8891 7.52513L12.4749 6.11091ZM9.29289 9.29289L6.11091 12.4749L7.52513 13.8891L10.7071 10.7071L9.29289 9.29289ZM13.8891 12.4749L10.7071 9.29289L9.29289 10.7071L12.4749 13.8891L13.8891 12.4749ZM10.7071 9.29289L7.52513 6.11091L6.11091 7.52513L9.29289 10.7071L10.7071 9.29289Z",
    fill: "#825DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ebf4c0045baf21ab743548130651eecb.svg";
export { ForwardRef as ReactComponent };